import React, { Component } from 'react';
import './styles.css';
import PropTypes from 'prop-types';
import { MultiYearScalarType } from '../../types';
import LabelDescriptionIcon from '../LabelDescriptionIcon';
import Chart from '../Chart';
import numeral from 'numeral';

class ProcurementInventory extends Component {
	render() {
		const { game } = this.props;
		const {
			beginningWhBottles,
			supplierOrderBottles,
			endingWhBottles,
			beginningWhApples,
			supplierOrderApples,
			endingWhApples
		} = game.procurement;

		return (
			<div className="procurement-inventory">
				<LabelDescriptionIcon icon="glassBottle" label="glassBottle" />
				{this.renderChart(
					beginningWhBottles,
					supplierOrderBottles,
					endingWhBottles
				)}
				<LabelDescriptionIcon icon="apple" label="apple" />
				{this.renderChart(
					beginningWhApples,
					supplierOrderApples,
					endingWhApples
				)}
			</div>
		);
	}

	formatData( value ) {
		return `${numeral(value).format('0.0a')}`;
	}

	renderChart(beginningWh, supplierOrder, endingWh) {
		const color = ['#92cde7', '#5eaed2', '#437d96'];

		return (
			<Chart
				option={{
					color,
					textStyle: {
						color: 'white'
					},

					legend: {
						data: [
							'Beginning Inventory',
							'Purchases (based on units internally produced)',
							'Ending Inventory'
						],
						textStyle: {
							color: 'white'
						}
					},

					xAxis: {
						type: 'category',
						data: ['YEAR 1', 'YEAR 2', 'YEAR 3']
					},

					yAxis: {
						type: 'value',
						data: ['u(Mil)'],
						axisLabel: {
							formatter : (value) => this.formatData(value),
							padding: [3, 5]
						},
						splitLine: {
							show: false
						}
					},

					series: [
						{
							name: 'Beginning Inventory',
							type: 'bar',
							barGap: 0.2,
							data: beginningWh,
							label: {
								fontWeight: 'lighter',
								fontSize: 9,
								normal: {
									formatter : (params) => this.formatData(params.value),
									show: true,
									position: 'top'
								}
							}
						},
						{
							name: 'Purchases (based on units internally produced)',
							type: 'bar',
							data: supplierOrder,
							label: {
								fontWeight: 'lighter',
								fontSize: 9,
								normal: {
									formatter : (params) => this.formatData(params.value),
									show: true,
									position: 'top'
								}
							}
						},
						{
							name: 'Ending Inventory',
							type: 'bar',
							data: endingWh,
							label: {
								fontWeight: 'lighter',
								fontSize: 9,
								normal: {
									formatter : (params) => this.formatData(params.value),
									show: true,
									position: 'top'
								}
							}
						}
					]
				}}
			/>
		);
	}
}

ProcurementInventory.propTypes = {
	game: PropTypes.shape({
		id: PropTypes.string.isRequired,
		procurement: PropTypes.shape({
			beginningWhBottles: MultiYearScalarType,
			beginningWhApples: MultiYearScalarType,
			supplierOrderBottles: MultiYearScalarType,
			supplierOrderApples: MultiYearScalarType,
			endingWhBottles: MultiYearScalarType,
			endingWhApples: MultiYearScalarType
		})
	})
};

export default ProcurementInventory;
